<template>
  <div v-if="display" :class="['dialog', 'dialog--new', 'dialog--shortage', 'dialog--input']">
    <div class="dialog-contain">
      <div class="dialog-tit">
        <span v-if="!onlyHideClose">
          <i v-if="!hideClose" class="dialog-close dialog-close--left" @click="hide"></i>
        </span>
        <p>{{ titleText ? titleText : "温馨提示" }}</p>
      </div>
      <div :class="['dialog-text', disableTextCenter ? '' : 'dialog-text--center']">
        <p v-html="msgText"></p>
      </div>
      <div v-if="!hideClose" class="btn-box">
        <button v-if="cancelText" class="btn btn-gray" @click="cancel">{{ cancelText || "取消" }}</button>
        <!-- 当有cancelText时，是有取消按钮，当只有一个按钮时又是没有回调时，就把confirm当cancel来用，因为是绿色的按钮比较好看 -->
        <button class="btn btn-green" @click="confirm">{{ confirmText || "确定" }}</button>
      </div>
    </div>
  </div>
</template>
<script>
// 使用示例参考文件最下面
import { reactive, toRefs } from "@vue/composition-api"
export default {
  props: {
    // 标题
    titleText: {
      type: String
    },

    // 提示信息
    msgText: {
      type: String
    },

    // 取消按钮文案(这个文案也当做需要展示取消按钮，不用多引入一个showCancelBtn的状态)
    cancelText: {
      type: String
    },

    // 点击确认的回调
    onConfirm: {
      type: Function
    },

    // 点击取消的回调
    onCancel: {
      type: Function
    },

    // 确认按钮
    confirmText: {
      type: String
    },

    hideClose: {
      type: Boolean
    },

    onlyHideClose: {
      type: Boolean
    },

    disableTextCenter: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const state = reactive({
      display: false
    })
    const show = () => {
      state.display = true
    }

    const hide = () => {
      state.display = false
    }

    const confirm = () => {
      if (props.onConfirm) {
        props.onConfirm(hide)
      } else {
        hide()
      }
    }

    const cancel = () => {
      if (props.onCancel) {
        props.onCancel(hide)
      } else {
        hide()
      }
    }

    return {
      ...toRefs(state),
      show,
      hide,
      confirm,
      cancel
    }
  }
}

// 当弹窗强制不允许用户关闭时使用，用于整个页面被禁用访问
// this.$Prompt({
//   hideClose: true,
//   msgText: promptText
// })

// 仅需要一个取消按钮，告知用户信息时使用
// this.$Prompt({
//   msgText: promptText
// })

// 需要两个按钮, 按钮1文案取消，按钮2用户确认后执行一定的逻辑
// this.$Prompt({
//   msgText: promptText,
//   cancelText: "取消",
//   onConfirm: () => {
//     this.confirmDemandAMSGoods(params, goods, userZoneInfo)
//   }
// })
</script>
